import * as React from 'react';
export const NRSvg = React.forwardRef(function NRSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M1.994 0h12.012A2 2 0 0 1 16 2.005V5H0V2.005C0 .894.893 0 1.994 0ZM0 7h16v2.995A1.997 1.997 0 0 1 14.006 12H1.994A2 2 0 0 1 0 9.995V7Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 4.5,
        cy: 9.5,
        r: 1.5,
        fill: '#FFF',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 5h16v2H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M14.933 7V5H16v2h-1.067ZM0 5h1.067v2H0V5Z',
      }),
    ),
  );
});
NRSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var NR = {
  category: 'flag',
  colorable: false,
  name: 'NR',
  svg: NRSvg,
};
